<template>
	<div class="couponsSaasDataList">
		<el-row class="function">
			<el-col :span="5">
				<el-input v-model.trim="name" placeholder="功能名称搜索" clearable></el-input>
			</el-col>
			<el-col :span="5">
				<el-checkbox v-model="checked" class="checked">仅查看启用功能</el-checkbox>
			</el-col>
		</el-row>
		<data-list :data="data" height="600" :columns="column" :table-style="{ name: 'mixture' }">
		</data-list>
		<div slot="bottom" class="total-prices">
			<span>总赠送:{{ totalGiv }}</span>
		</div>
	</div>
</template>

<script>
import setmeal from '@/backend/services/account/setmeal.js';
import filters from '@/mixins/filters.js';

let { money } = filters.filters;

export default {
	name: 'couponsSaasDataList',
	props: ['value', 'currency'],
	data() {
		let that = this;
		return {
			name: '',
			checked: false,
			dataObj: {},
			currencyCopy: '',
			column: [
				{
					label: '使用',
					bind: 'status',
					type: 'checkbox',
					width: 50,
					align: 'center',
					change(val, row) {
						let { dataObj, currency } = that;

						dataObj[currency].forEach(item => {
							if (item.id == row.id) {
								item.status = !row.status ? true : false;
							}
						});
						that.setData();
					},
				},
				{
					label: '功能名称',
					bind: 'name',
					type: 'popoverView',
					width: 300,
				},
				{
					label: '版本',
					bind: 'version',
				},
				{
					label: '单价',
					bind: 'price',
					type: 'percentage',
					dataStyle(val) {
						let { currency } = that;
						return money(val, currency);
					},
				},
				{
					label: '量/时间',
					bind: 'number',
					type: 'percentage',
					dataStyle(val, row) {
						return `${val}${row.unitName}`;
					},
				},
				{
					label: '单位',
					bind: 'unitName',
				},
				{
					label: '赠送最大量级',
					type: 'inputNumber',
					bind: 'functionNumber',
					min: 1,
					size: 'mini',
					align: 'center',
					change(val, _oldVal, row) {
						let { dataObj, currency } = that;
						dataObj[currency].forEach(item => {
							if (item.id == row.id) {
								item.functionNumber = val;
								item.totalPrice = val * item.price;
							}
						});
						that.setData();
					},
				},
				{
					label: '价格',
					bind: 'totalPrice',
					type: 'percentage',
					dataStyle(val) {
						let { currency } = that;
						return money(val, currency);
					},
				},
			],
		};
	},
	computed: {
		data(self) {
			let { dataObj } = self;
			let list = self.filterList(dataObj);
			return list;
		},
		totalGiv(self) {
			let { currency, dataObj } = self;

			let totalGiv = 0;

			if (!dataObj[currency]) return money(totalGiv, currency);

			dataObj[currency].map(item => {
				if (item.status) {
					totalGiv += item.totalPrice;
				}
			});
			return money(totalGiv, currency);
		},
	},
	mounted() {
		this.getActiveFeatureList();
		this.currencyCopy = this.currency;
	},
	methods: {
		// 获取以启用套餐列表
		async getActiveFeatureList() {
			let res = await setmeal.featureDropDownList();
			this.dataObj = this.transformData(res.data);
			this.setData();
		},
		// 数据处理
		transformData(data) {
			let { value, currency: _currency } = this;

			const result = {};

			data.forEach(item => {
				item.priceList.forEach(priceEntry => {
					const { currency, price } = priceEntry;

					// 如果 result 中没有当前 currency 的键，则创建一个空数组
					if (!result[currency]) {
						result[currency] = [];
					}

					let custom = {
						status: false, // 选中状态
						functionNumber: 1, // 量级
						totalPrice: 1 * price,
					};

					// 构造符合要求的对象
					const formattedItem = {
						...Object.assign(item, custom),
						currency,
						price,
					};

					// 将对象添加到相应的 currency 分类中
					result[currency].push(formattedItem);
				});
			});

			if (value) {
				value.forEach(item => {
					if (result[_currency]) {
						result[_currency] = result[_currency].map(_item => {
							if (_item.id === item.id) {
								_item.functionNumber = item.functionNumber;
								_item.totalPrice = item.functionNumber * _item.price;
								_item.currency = _currency;
								_item.status = true;
							}

							return _item;
						});
					}
				});
			}

			return result;
		},
		// 自定义过滤
		filterList(obj) {
			let { name, checked, currency, currencyCopy } = this;

			var arr;
			var reg = new RegExp(name);
			if (!obj[currency]) return [];

			arr = obj[currency].filter(({ name }) => {
				return reg.test(name);
			});

			if (checked) {
				arr = arr.filter(item => {
					return item.isEnable;
				});
			}

			// 在切换币种时清除已选项
			if (currency !== currencyCopy) {
				arr.forEach(item => {
					item.status = false;
				});

				this.currencyCopy = currency;
			}
			return arr;
		},
		// 向外抛出数据
		setData() {
			let { dataObj, currency } = this;
			let inputObj = _.cloneDeep(dataObj);
			let result = inputObj[currency]
				.filter(item => item.status)
				.map(item => {
					let { functionNumber, id } = item;
					return { functionNumber, id };
				});
			this.$emit('input', result);
		},
	},
};
</script>

<style lang="scss" scoped>
.couponsSaasDataList {
	.total-prices {
		width: 100%;
		padding: 10px 0;
		padding-right: 20px;
		text-align: right;
		font-size: 18px;
		font-weight: bold;

		span {
			margin-left: 20px;
		}
	}

	.function {
		margin: 10px 0 10px 0;
	}

	.checked {
		margin-left: 20px;
	}
}
</style>
